import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=4a024d5e&scoped=true&"
import script from "./logout.vue?vue&type=script&lang=js&"
export * from "./logout.vue?vue&type=script&lang=js&"
import style0 from "./logout.vue?vue&type=style&index=0&id=4a024d5e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a024d5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\public\\Isaura\\id.es6.vn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a024d5e')) {
      api.createRecord('4a024d5e', component.options)
    } else {
      api.reload('4a024d5e', component.options)
    }
    module.hot.accept("./logout.vue?vue&type=template&id=4a024d5e&scoped=true&", function () {
      api.rerender('4a024d5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authen/logout.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/authen/logout.vue
// module id = 705
// module chunks = 5